import {ChangeDetectorRef, Component, EventEmitter, Inject, Input, Output} from "@angular/core";
import { ConnextAccount } from "../connext-account";
import { ConnextAddressToken } from "../connext-address-token";
import { State } from "./activate-ccd-connext-trial-modal-state";

@Component({
	selector: "activate-ccd-dealer-connext-trial-step",
	template: `
		<modal
			(close)="onModalClosed()"
			modalClasses="modal-wide"
			[clickToClose]="false">
			<header class="modal_header">
				<h2 class="text-center">
					Activate Dealer {{ getTrialTypeName() }} Trial
					<br>
					<small style="font-size: 12px; font-weight: 400;">
						Step 3 of 3
					</small>
				</h2>
			</header>
			<activate-ccd-connext-trial-modal-body
				[customerGuid]="customerGuid"
				[masterAircraftUuid]="masterAircraftUuid"
				[selectedBillingAccount]="selectedBillingAccount"
				[selectedConnextAddressToken]="selectedConnextAddressToken"
				[trialType]="getTrialType()"
				(stateUpdate)="onStateUpdate($event)"
			></activate-ccd-connext-trial-modal-body>
			<footer class="modal_footer">
				<div>
					<button
						(click)="onModalClosed()"
						class="button button-secondary py-1 px-4">
						CANCEL
					</button>
					<button
						(click)="onDealerConnextTrialSubscribed()"
						[disabled]="shouldDisableContinueButton()"
						class="button {{getContinueButtonClass()}} py-1 px-4 modal_buttons">
						{{getContinueButtonText()}}
					</button>
				</div>
			</footer>
		</modal>
	`
})

export class ActivateCcdDealerConnextTrialStepComponent {
	@Input() masterAircraftUuid: string;
	@Input() customerGuid: string;
	@Input() selectedBillingAccount: ConnextAccount;
	@Input() selectedConnextAddressToken: ConnextAddressToken;
	@Input() isTelephonyDevice: boolean;
	@Input() isLteWifiDevice: boolean;
	@Output() dealerConnextTrialSubscribed = new EventEmitter<string>();
	@Output() modalClosed = new EventEmitter();

	currentState: State = State.Loading;
	v2DealerLteWifiTrialType: number;
	v2DealerSatelliteTrialType: number;

	constructor(
		private changeDetector: ChangeDetectorRef,
		@Inject("v2DealerLteWifiTrialType") v2DealerLteTrialType: number,
		@Inject("v2DealerSatelliteTrialType") v2DealerSatelliteTrialType: number
	) {
		this.v2DealerLteWifiTrialType = v2DealerLteTrialType;
		this.v2DealerSatelliteTrialType = v2DealerSatelliteTrialType;
	}

	onModalClosed() {
		this.modalClosed.emit();
	}

	onDealerConnextTrialSubscribed() {
		this.dealerConnextTrialSubscribed.emit();
		this.refreshPage();
	}

	refreshPage() {
		window.location.reload();
	}

	shouldDisableContinueButton(): boolean {
		switch (this.currentState) {
			case State.ClaimedTrialsRequestFailed:
			case State.SubscriptionAlreadyClaimed:
			case State.SubscriptionAlreadyActive:
			case State.SubscriptionInfo:
			case State.ConnextTermsAndConditions:
			case State.SubscriptionActivationRequestFailed:
			case State.SubscriptionActivationFailedWithReason:
			case State.SubscriptionJobStatusTimeout:
			case State.SubscriptionJobStatusSucceeded:
				return false;
			case State.Loading:
			case State.RetrievingClaimedTrials:
			case State.ActivatingSubscription:
			case State.SubscriptionJobStatusWaiting:
			default:
				return true;
		}
	}

	getContinueButtonClass(): string {
		if (this.currentState === State.SubscriptionJobStatusSucceeded || this.currentState === State.SubscriptionJobStatusTimeout) {
			return "button-primary";
		} else {
			return "button-secondary";
		}
	}

	getContinueButtonText(): string {
		switch (this.currentState) {
			case State.ClaimedTrialsRequestFailed:
			case State.SubscriptionAlreadyClaimed:
			case State.SubscriptionAlreadyActive:
			case State.SubscriptionInfo:
			case State.ConnextTermsAndConditions:
			case State.SubscriptionActivationRequestFailed:
			case State.SubscriptionActivationFailedWithReason:
				return "Skip for Now";
			case State.SubscriptionJobStatusTimeout:
			case State.SubscriptionJobStatusSucceeded:
				return "Finish";
			case State.Loading:
			case State.RetrievingClaimedTrials:
			case State.ActivatingSubscription:
			default:
				return "Continue";
		}
	}

	onStateUpdate(newState: State) {
		this.currentState = newState;
		this.changeDetector.detectChanges();
	}

	getTrialType() {
		if (this.isLteWifiDevice) {
			return this.v2DealerLteWifiTrialType;
		} else {
			return this.v2DealerSatelliteTrialType;
		}
	}

	getTrialTypeName() {
		if (this.isLteWifiDevice) {
			return "LTE & Wi-Fi";
		} else {
			return "Satellite";
		}
	}
}
